// extracted by mini-css-extract-plugin
export default {"needMoreDateContainer":"needMoreDate_needMoreDateContainer__ipQA7","errorIcon":"needMoreDate_errorIcon__bGLzC","errorMessage":"needMoreDate_errorMessage__QhzYS"};